/**
 * ReportingHub.tsx — Redirect to unified reports catalog hub.
 *
 * Route: /reporting
 *
 * W17-ReportsCatalog-Hub: The unified catalog hub lives at /#/reports.
 * This component redirects there immediately.
 */
import { useEffect } from "react";
import { useLocation } from "wouter";

export default function ReportingHub() {
  const [, navigate] = useLocation();

  useEffect(() => {
    navigate("/reports");
  }, [navigate]);

  return null;
}
